import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function EditSale() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ customer_id: '', bank_id: '', status: 'final' });
  const [items, setItems] = useState([]);
  const [allItems, setAllItems] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    axios.get(`/sales/${id}`).then(res => {
      setForm({ customer_id: res.data.customer_id, bank_id: res.data.bank_id, status: res.data.status });
      setItems(res.data.items);
    });
    axios.get('/items').then(res => setAllItems(res.data));
    axios.get('/customers').then(res => setCustomers(res.data));
    axios.get('/banks').then(res => setBanks(res.data));
  }, [id]);

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = field === 'quantity' || field === 'price' ? parseFloat(value) || 0 : value;
    updated[index].total = (parseFloat(updated[index].quantity) || 0) * (parseFloat(updated[index].price) || 0);
    setItems(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await axios.put(`/sales/${id}`, { ...form, items });
    toast.success('Sale updated!');
    navigate('/sales');
  };

  const grandTotal = items.reduce((sum, i) => {
    const itemTotal = parseFloat(i.total) || ((parseFloat(i.quantity) || 0) * (parseFloat(i.price) || 0));
    return sum + itemTotal;
  }, 0);

  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Edit Sale #{id}</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <select value={form.customer_id} onChange={e => setForm({ ...form, customer_id: e.target.value })} className="border p-2 w-full">
            <option value="">Select Customer</option>
            {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>

          <select value={form.bank_id} onChange={e => setForm({ ...form, bank_id: e.target.value })} className="border p-2 w-full">
            <option value="">Select Bank</option>
            {banks.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>

          <select value={form.status} onChange={e => setForm({ ...form, status: e.target.value })} className="border p-2 w-full">
            <option value="quotation">Quotation</option>
            <option value="final">Final</option>
          </select>

          <table className="w-full border mt-4">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2">Item</th>
                <th className="border p-2">Qty</th>
                <th className="border p-2">Price</th>
                <th className="border p-2">Total</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td className="border p-2">
                    <select className="w-full border p-1" value={item.item_id} onChange={e => handleItemChange(idx, 'item_id', e.target.value)}>
                      {allItems.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                    </select>
                  </td>
                  <td className="border p-2">
                    <input type="number" value={item.quantity} onChange={e => handleItemChange(idx, 'quantity', e.target.value)} className="border p-1 w-full" />
                  </td>
                  <td className="border p-2">
                    <input type="number" value={item.price} onChange={e => handleItemChange(idx, 'price', e.target.value)} className="border p-1 w-full" />
                  </td>
                  <td className="border p-2">${(parseFloat(item.total) || 0).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <p className="text-right font-bold text-lg mt-2">Grand Total: ${grandTotal.toFixed(2)}</p>
          <button type="submit" className="bg-green-600 text-white px-6 py-2 rounded">Update Sale</button>
        </form>
      </div>
    </div>
  );
}

export default EditSale;